import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";

export const DRIVE_FOLDER_AUTO_KEY = "kr_drive_folder_auto";

// Dispara a verificação a partir de qualquer ponto de aceite de ticket.
// O componente DriveFolderPrompt (montado uma vez no layout) escuta esse evento.
export const maybeCreateDriveFolder = contact => {
  if (!contact) return;
  window.dispatchEvent(
    new CustomEvent("kr:drive-folder-maybe", { detail: { contact } })
  );
};

const requestFolder = async contact => {
  try {
    await api.post(`/contacts/${contact.id}/drive-folder`);
    toast.success(`Pasta de ${contact.name} está sendo criada no Drive`);
  } catch (err) {
    toastError(err);
  }
};

const DriveFolderPrompt = () => {
  const [contact, setContact] = useState(null);
  const [autoChecked, setAutoChecked] = useState(false);

  useEffect(() => {
    const handler = e => {
      const c = e.detail?.contact;
      if (!c || c.isGroup || c.driveFolderId) return;
      if (localStorage.getItem(DRIVE_FOLDER_AUTO_KEY) === "always") {
        requestFolder(c);
        return;
      }
      setAutoChecked(false);
      setContact(c);
    };
    window.addEventListener("kr:drive-folder-maybe", handler);
    return () => window.removeEventListener("kr:drive-folder-maybe", handler);
  }, []);

  const handleClose = () => setContact(null);

  const handleConfirm = () => {
    if (autoChecked) {
      localStorage.setItem(DRIVE_FOLDER_AUTO_KEY, "always");
    }
    requestFolder(contact);
    setContact(null);
  };

  return (
    <Dialog open={!!contact} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Criar pasta no Drive?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Criar a pasta de arquivos de <strong>{contact?.name}</strong> no
          Google Drive? Ela nasce no padrão "Nome - Telefone" com as subpastas
          de documentos, chat e pedidos.
        </DialogContentText>
        <FormControlLabel
          control={
            <Checkbox
              checked={autoChecked}
              onChange={e => setAutoChecked(e.target.checked)}
              color="primary"
            />
          }
          label="Sempre criar automaticamente (não perguntar mais)"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Agora não
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Criar pasta
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DriveFolderPrompt;
